import React, { useState } from 'react';
import { COLORS } from '../App';

export default function TemplateSelector({ templates, selectedId, onSelect, propertyType, onSkip }) {
  const [selected, setSelected] = useState(selectedId || null);

  if (!templates || templates.length === 0) {
    return (
      <div style={{ padding: 16, background: '#FFEBEE', borderLeft: '4px solid #EF5350', borderRadius: 8, fontSize: 13, color: '#C62828' }}>
        No templates available. Upload a template in Admin > UW Templates.
      </div>
    );
  }

  return (
    <div>
      {templates.map(t => {
        const isSelected = selected === t.id;
        const isMatch = propertyType && t.property_type === propertyType;
        const schema = t.field_schema || {};
        const inputCount = schema.input_cells ? Object.keys(schema.input_cells).length : 0;
        const formulaCount = schema.formula_cells ? schema.formula_cells.length : 0;

        return (
          <div key={t.id} onClick={() => setSelected(t.id)}
            style={{
              border: isSelected ? '2px solid #C9A84C' : '1px solid #E2E6EC',
              borderRadius: 8, padding: '12px 16px', marginBottom: 8, cursor: 'pointer',
              background: isSelected ? '#FFFDF5' : '#fff',
              display: 'flex', alignItems: 'center', gap: 12, transition: 'all 0.1s',
            }}
            onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#F5F7FA'; }}
            onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = '#fff'; }}>
            <div style={{
              width: 18, height: 18, borderRadius: '50%', border: isSelected ? '6px solid #C9A84C' : '2px solid #CCC',
              flexShrink: 0,
            }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: COLORS.navy }}>{t.template_name}</div>
              <div style={{ fontSize: 12, color: COLORS.textLight, marginTop: 2 }}>
                <span style={{
                  display: 'inline-block', padding: '1px 8px', borderRadius: 10, fontSize: 10, fontWeight: 600, marginRight: 6,
                  background: isMatch ? '#E8F5E9' : '#F5F5F5',
                  color: isMatch ? '#2E7D32' : '#999',
                }}>{t.property_type}</span>
                v{t.version}
                {inputCount > 0 && ` | ${inputCount} input cells`}
                {formulaCount > 0 && ` | ${formulaCount} formulas`}
              </div>
              {!isMatch && propertyType && (
                <div style={{ fontSize: 11, color: '#F57F17', marginTop: 2 }}>Type mismatch: this template is for {t.property_type}</div>
              )}
            </div>
          </div>
        );
      })}

      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button onClick={() => { if (selected) onSelect(selected); }}
          disabled={!selected}
          style={{
            padding: '10px 20px', background: selected ? COLORS.gold : '#CCC', color: COLORS.navy,
            border: 'none', borderRadius: 6, fontWeight: 600, fontSize: 13,
            cursor: selected ? 'pointer' : 'not-allowed',
          }}>
          Assign Template
        </button>
        {onSkip && (
          <button onClick={onSkip}
            style={{ padding: '10px 20px', background: 'transparent', color: COLORS.textLight, border: `1px solid ${COLORS.border}`, borderRadius: 6, fontSize: 13, cursor: 'pointer' }}>
            Skip for Now
          </button>
        )}
      </div>
    </div>
  );
}
